(() => {
  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency: window.Shopify?.currency?.active || 'USD'}).format((cents || 0)/100); }
    catch (_) { return `$${((cents || 0)/100).toFixed(2)}`; }
  };
  const norm = (v) => String(v || '').trim().toLowerCase();
  const cleanUrl = (v) => String(v || '').split('?')[0];

  function init(root){
    const jsonEl = root.querySelector('[data-bia-product-json]');
    if (!jsonEl) return;
    let data; try { data = JSON.parse(jsonEl.textContent); } catch (_) { return; }
    const variants = data.variants || [];
    const colorIndex = Number(data.colorOptionIndex ?? -1);
    const fitIndex = Number(data.fitOptionIndex ?? -1);
    const optionGroups = [...root.querySelectorAll('.bia-product-option')];
    const variantInput = root.querySelector('[data-bia-variant-id]');
    const priceEl = root.querySelector('[data-bia-price]');
    const compareEl = root.querySelector('[data-bia-compare]');
    const addBtn = root.querySelector('[data-bia-add-to-cart]');
    const addLabel = root.querySelector('[data-bia-add-label]');
    const mainImg = root.querySelector('.bia-product-main-image');
    const videoHost = root.querySelector('[data-bia-video-host]');
    const zoomButton = root.querySelector('[data-bia-zoom-open]');
    const thumbs = [...root.querySelectorAll('[data-bia-thumb]')];
    const galleryNav = root.querySelector('[data-bia-gallery-nav]');
    const galleryCount = root.querySelector('[data-bia-gallery-count]');
    let galleryColor = null;
    let galleryImages = [];
    let galleryActive = null;
    const colorTiles = [...root.querySelectorAll('[data-bia-variant-tile]')];

    const selected = optionGroups.map(group => group.querySelector('[data-bia-option-value].is-selected')?.dataset.value || group.querySelector('[data-bia-option-value]')?.dataset.value || '');

    function exactVariant(){
      if (!optionGroups.length) return variants.find(v => String(v.id) === String(variantInput?.value)) || variants[0];
      return variants.find(v => v.options.every((opt, i) => opt === selected[i]));
    }

    function bestVariant(changedIndex = -1, changedValue = ''){
      const exact = exactVariant();
      if (exact) return exact;
      if (changedIndex >= 0) {
        const preserveOthers = variants.find(v => v.available && v.options[changedIndex] === changedValue && v.options.every((opt,i) => i === changedIndex || !selected[i] || opt === selected[i]));
        if (preserveOthers) return preserveOthers;
        const anyAvailable = variants.find(v => v.available && v.options[changedIndex] === changedValue);
        if (anyAvailable) return anyAvailable;
        const anyMatch = variants.find(v => v.options[changedIndex] === changedValue);
        if (anyMatch) return anyMatch;
      }
      return variants.find(v => v.available) || variants[0];
    }

    let imageRequest = 0;
    function swapImage(img, src, alt){
      if (!img || !src) return;
      const request = ++imageRequest;
      if (cleanUrl(img.src) === cleanUrl(src)) { if (alt) img.alt = alt; img.style.opacity = '1'; return; }
      img.style.opacity = '.55';
      const pre = new Image();
      const candidate = new URL(src, location.href);
      const responsiveSrcset = [360,540,720,1000,1400,1800,2200,2600].map(width => {
        candidate.searchParams.set('width', String(width));
        return `${candidate.href} ${width}w`;
      }).join(', ');
      const responsiveSizes = '(min-width: 990px) 48vw, (min-width: 750px) 50vw, 100vw';
      pre.onload = () => {
        if (request !== imageRequest) return;
        img.sizes = responsiveSizes;
        img.srcset = responsiveSrcset;
        img.src = src;
        if (alt) img.alt = alt;
        img.style.opacity = '1';
      };
      pre.onerror = () => { if (request === imageRequest) img.style.opacity = '1'; };
      pre.sizes = responsiveSizes;
      pre.srcset = responsiveSrcset;
      pre.src = src;
    }

    function syncControlsToVariant(variant){
      if (!variant) return;
      variant.options.forEach((value, index) => {
        selected[index] = value;
        const group = optionGroups[index];
        if (!group) return;
        group.querySelectorAll('[data-bia-option-value]').forEach(btn => btn.classList.toggle('is-selected', btn.dataset.value === value));
        const label = group.querySelector('[data-bia-selected-label]');
        if (label) label.textContent = value;
      });
    }

    function refreshAvailability(){
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-bia-option-value]').forEach(btn => {
          const value = btn.dataset.value;
          const possible = variants.some(v => v.available && v.options[groupIndex] === value && (fitIndex < 0 || groupIndex === fitIndex || v.options[fitIndex] === selected[fitIndex]));
          btn.disabled = !possible;
          btn.setAttribute('aria-pressed', String(btn.classList.contains('is-selected')));
        });
      });
    }

    function showGalleryImage(active){
      if (!active || !galleryImages.includes(active)) return;
      galleryActive = active;
      thumbs.forEach(t => {
        t.classList.toggle('is-active', t === active);
        t.setAttribute('aria-pressed', String(t === active));
      });
      const isVideo = active.dataset.mediaType === 'video';
      if (videoHost) {
        videoHost.querySelector('video')?.pause();
        videoHost.replaceChildren();
        videoHost.hidden = !isVideo;
        if (isVideo) {
          const template = root.querySelector(`[data-bia-video-template="${active.dataset.mediaId}"]`);
          if (template) videoHost.append(template.content.cloneNode(true));
          const video = videoHost.querySelector('video');
          if (video) {
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.play().catch(() => {});
          }
        }
      }
      if (mainImg) mainImg.hidden = isVideo;
      if (zoomButton) zoomButton.hidden = isVideo;
      if (!isVideo) swapImage(mainImg, active.dataset.image, active.dataset.alt);
      if (galleryCount) galleryCount.textContent = `${galleryImages.indexOf(active) + 1} / ${galleryImages.length}`;
    }

    function stepGallery(direction){
      if (galleryImages.length < 2) return;
      const index = Math.max(0, galleryImages.indexOf(galleryActive));
      showGalleryImage(galleryImages[(index + direction + galleryImages.length) % galleryImages.length]);
    }

    function updateGallery(variant){
      const selectedColor = colorIndex >= 0 ? (variant?.options?.[colorIndex] || selected[colorIndex] || '') : '';
      const c = norm(selectedColor);
      const exactThumbs = c ? thumbs.filter(t => norm(t.dataset.color) === c) : [];
      const hasExact = exactThumbs.length > 0;
      thumbs.forEach(t => {
        const tc = norm(t.dataset.color);
        t.hidden = hasExact ? !(tc === c || !tc) : Boolean(tc && c && tc !== c);
      });
      galleryImages = thumbs.filter(t => !t.hidden);
      if (galleryNav) galleryNav.hidden = galleryImages.length < 2;
      let active = galleryColor === c && galleryImages.includes(galleryActive) ? galleryActive : null;
      if (!active && variant?.mediaId) active = galleryImages.find(t => String(t.dataset.mediaId) === String(variant.mediaId));
      if (!active && variant?.image) active = galleryImages.find(t => cleanUrl(t.dataset.image) === cleanUrl(variant.image));
      if (!active) active = exactThumbs[0] || galleryImages[0];
      galleryColor = c;
      if (active) showGalleryImage(active);
      else if (variant?.image) swapImage(mainImg, variant.image, selectedColor);
      colorTiles.forEach(tile => tile.classList.toggle('is-selected', norm(tile.dataset.color) === c));
    }

    function applyVariant(variant){
      if (!variant) return;
      syncControlsToVariant(variant);
      if (fitIndex >= 0) {
        const fit = variant.options[fitIndex];
        root.querySelectorAll('[data-bia-fit-label]').forEach(el => { el.textContent = `${fit} fit`; });
        const guide = data.fitGuides?.[norm(fit).startsWith('women') ? 'women' : 'men'];
        const link = root.querySelector('.bia-size-guide');
        if (link && guide?.url) {
          link.href = guide.url;
          link.dataset.guideTitle = guide.title || `${fit} size guide`;
          if (guide.image) link.dataset.guideImage = guide.image;
          else delete link.dataset.guideImage;
        }
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.priceFormatted || money(variant.price);
      if (compareEl){
        const onSale = variant.compareAtPrice && variant.compareAtPrice > variant.price;
        compareEl.classList.toggle('is-hidden', !onSale);
        compareEl.textContent = onSale ? (variant.compareAtPriceFormatted || money(variant.compareAtPrice)) : '';
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      updateGallery(variant);
      try { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); } catch (_) {}
      refreshAvailability();
    }

    optionGroups.forEach((group, groupIndex) => {
      group.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-bia-option-value]');
        if (!btn || btn.disabled) return;
        selected[groupIndex] = btn.dataset.value;
        applyVariant(bestVariant(groupIndex, btn.dataset.value));
      });
    });

    thumbs.forEach(btn => btn.addEventListener('click', () => showGalleryImage(btn)));
    root.querySelector('[data-bia-gallery-prev]')?.addEventListener('click', () => stepGallery(-1));
    root.querySelector('[data-bia-gallery-next]')?.addEventListener('click', () => stepGallery(1));
    const mainMedia = root.querySelector('.bia-product-main-media');
    let touchStart = null;
    mainMedia?.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch') touchStart = {x:event.clientX,y:event.clientY};
    }, {passive:true});
    mainMedia?.addEventListener('pointerup', event => {
      if (!touchStart) return;
      const dx = event.clientX - touchStart.x;
      const dy = event.clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) stepGallery(dx < 0 ? 1 : -1);
    }, {passive:true});
    mainMedia?.addEventListener('pointercancel', () => { touchStart = null; }, {passive:true});

    colorTiles.forEach(tile => tile.addEventListener('click', () => {
      if (colorIndex < 0 || !tile.dataset.color) return;
      selected[colorIndex] = tile.dataset.color;
      applyVariant(bestVariant(colorIndex, tile.dataset.color));
    }));

    const qty = root.querySelector('[data-bia-qty-input]');
    root.querySelector('[data-bia-qty-minus]')?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, Number(qty.value || 1) - 1); });
    root.querySelector('[data-bia-qty-plus]')?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, Number(qty.value || 1) + 1); });

    applyVariant(bestVariant());
  }

  document.querySelectorAll('[data-bia-product-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll?.('[data-bia-product-root]').forEach(init));
})();


